// extracted by mini-css-extract-plugin
export default {"display":"Advice_display__roeD5","button":"Advice_button__gwpaB","h2":"Advice_h2__W5Eqs","p":"Advice_p__SHibA","divider":"Advice_divider__jsJZf"};